"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.random = void 0;

/**
 * Generate random number between interval
 *
 * @param  {Object}   arg1      Props
 * @param  {number}   arg1.min  The minimum
 * @param  {number}   arg1.max  The maximum
 *
 * @return {integer}
 */
var random = function random(_ref) {
  var min = _ref.min,
      max = _ref.max;
  return Math.floor(Math.random() * (max - min + 1) + min);
};

exports.random = random;